import {
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  ScrollView,
  StyleSheet,
} from 'react-native';
import { SelectedSetsData } from '../../components/SetsSelectedData';
import { useSentenceSetContext } from '../../hooks/useSentencesetContext';
import { Filter } from './Filter';
import { Header } from './Header';

const innerStyles = StyleSheet.create({
  container: { flex: 1 },
  scrollStyle: { flex: 1, margin: 15 },
});

export function SetsSelectedWrapper({ props }) {
  const {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    scrollViewRef,
  } = useSentenceSetContext();

  const propz = {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    props,
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={{ flex: 1 }}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 80 : 0}
    >
      <SafeAreaView style={innerStyles.container}>
        <Header props={props} />
        <ScrollView ref={scrollViewRef} style={innerStyles.scrollStyle}>
          <Filter />
          <SelectedSetsData type="sentence" {...propz} />
        </ScrollView>
      </SafeAreaView>
    </KeyboardAvoidingView>
  );
}
